export default {"src":"/_next/static/media/LogoMark24Icon.2e6f037b.svg","height":24,"width":24};